import NotificationContent from './NotificationContent';

export default NotificationContent;